import { render, staticRenderFns } from "./ColorButton.vue?vue&type=template&id=c325f25e"
import script from "./ColorButton.vue?vue&type=script&lang=js"
export * from "./ColorButton.vue?vue&type=script&lang=js"
import style0 from "./ColorButton.vue?vue&type=style&index=0&id=c325f25e&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c325f25e')) {
      api.createRecord('c325f25e', component.options)
    } else {
      api.reload('c325f25e', component.options)
    }
    module.hot.accept("./ColorButton.vue?vue&type=template&id=c325f25e", function () {
      api.rerender('c325f25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/assistButton/ColorButton.vue"
export default component.exports